export const Paths = {
  /** Auth Module Module */

  LOGIN: "/",
  SIGN_UP: "/sign-up",
  DASHBOARD: "/dashboard",
  FORGOTPASSWORD: "/forgot-password",
};
